/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CommentDto } from '../models/comment-dto';
import { commentsCommentIdDelete } from '../fn/comments/comments-comment-id-delete';
import { CommentsCommentIdDelete$Params } from '../fn/comments/comments-comment-id-delete';
import { commentsCommentIdPut$Json } from '../fn/comments/comments-comment-id-put-json';
import { CommentsCommentIdPut$Json$Params } from '../fn/comments/comments-comment-id-put-json';
import { commentsCommentIdPut$Plain } from '../fn/comments/comments-comment-id-put-plain';
import { CommentsCommentIdPut$Plain$Params } from '../fn/comments/comments-comment-id-put-plain';
import { commentsCommentIdResolvePost$Json } from '../fn/comments/comments-comment-id-resolve-post-json';
import { CommentsCommentIdResolvePost$Json$Params } from '../fn/comments/comments-comment-id-resolve-post-json';
import { commentsCommentIdResolvePost$Plain } from '../fn/comments/comments-comment-id-resolve-post-plain';
import { CommentsCommentIdResolvePost$Plain$Params } from '../fn/comments/comments-comment-id-resolve-post-plain';
import { commentsPost$Json } from '../fn/comments/comments-post-json';
import { CommentsPost$Json$Params } from '../fn/comments/comments-post-json';
import { commentsPost$Plain } from '../fn/comments/comments-post-plain';
import { CommentsPost$Plain$Params } from '../fn/comments/comments-post-plain';
import { commentsTargetTypeTargetIdGet$Json } from '../fn/comments/comments-target-type-target-id-get-json';
import { CommentsTargetTypeTargetIdGet$Json$Params } from '../fn/comments/comments-target-type-target-id-get-json';
import { commentsTargetTypeTargetIdGet$Plain } from '../fn/comments/comments-target-type-target-id-get-plain';
import { CommentsTargetTypeTargetIdGet$Plain$Params } from '../fn/comments/comments-target-type-target-id-get-plain';

@Injectable({ providedIn: 'root' })
export class CommentsApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `commentsPost()` */
  static readonly CommentsPostPath = '/comments';

  /**
   * Add comment.
   *
   * Adds a new comment on a dashboard, dashboard tile or query.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  commentsPost$Plain$Response(params?: CommentsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CommentDto>> {
    const obs = commentsPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Add comment.
   *
   * Adds a new comment on a dashboard, dashboard tile or query.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commentsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  commentsPost$Plain(params?: CommentsPost$Plain$Params, context?: HttpContext): Observable<CommentDto> {
    const resp = this.commentsPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CommentDto>): CommentDto => r.body)
    );
  }

  /**
   * Add comment.
   *
   * Adds a new comment on a dashboard, dashboard tile or query.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentsPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  commentsPost$Json$Response(params?: CommentsPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CommentDto>> {
    const obs = commentsPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Add comment.
   *
   * Adds a new comment on a dashboard, dashboard tile or query.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commentsPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  commentsPost$Json(params?: CommentsPost$Json$Params, context?: HttpContext): Observable<CommentDto> {
    const resp = this.commentsPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CommentDto>): CommentDto => r.body)
    );
  }

  /** Path part for operation `commentsTargetTypeTargetIdGet()` */
  static readonly CommentsTargetTypeTargetIdGetPath = '/comments/{targetType}/{targetId}';

  /**
   * List comments for target.
   *
   * Lists comments for a specific dashboard, tile or query.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentsTargetTypeTargetIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentsTargetTypeTargetIdGet$Plain$Response(params: CommentsTargetTypeTargetIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CommentDto>>> {
    const obs = commentsTargetTypeTargetIdGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List comments for target.
   *
   * Lists comments for a specific dashboard, tile or query.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commentsTargetTypeTargetIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentsTargetTypeTargetIdGet$Plain(params: CommentsTargetTypeTargetIdGet$Plain$Params, context?: HttpContext): Observable<Array<CommentDto>> {
    const resp = this.commentsTargetTypeTargetIdGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<CommentDto>>): Array<CommentDto> => r.body)
    );
  }

  /**
   * List comments for target.
   *
   * Lists comments for a specific dashboard, tile or query.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentsTargetTypeTargetIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentsTargetTypeTargetIdGet$Json$Response(params: CommentsTargetTypeTargetIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CommentDto>>> {
    const obs = commentsTargetTypeTargetIdGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List comments for target.
   *
   * Lists comments for a specific dashboard, tile or query.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commentsTargetTypeTargetIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentsTargetTypeTargetIdGet$Json(params: CommentsTargetTypeTargetIdGet$Json$Params, context?: HttpContext): Observable<Array<CommentDto>> {
    const resp = this.commentsTargetTypeTargetIdGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<CommentDto>>): Array<CommentDto> => r.body)
    );
  }

  /** Path part for operation `commentsCommentIdPut()` */
  static readonly CommentsCommentIdPutPath = '/comments/{commentId}';

  /**
   * Edit comment.
   *
   * Updates the text of an existing comment.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentsCommentIdPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  commentsCommentIdPut$Plain$Response(params: CommentsCommentIdPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CommentDto>> {
    const obs = commentsCommentIdPut$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Edit comment.
   *
   * Updates the text of an existing comment.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commentsCommentIdPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  commentsCommentIdPut$Plain(params: CommentsCommentIdPut$Plain$Params, context?: HttpContext): Observable<CommentDto> {
    const resp = this.commentsCommentIdPut$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CommentDto>): CommentDto => r.body)
    );
  }

  /**
   * Edit comment.
   *
   * Updates the text of an existing comment.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentsCommentIdPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  commentsCommentIdPut$Json$Response(params: CommentsCommentIdPut$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CommentDto>> {
    const obs = commentsCommentIdPut$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Edit comment.
   *
   * Updates the text of an existing comment.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commentsCommentIdPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  commentsCommentIdPut$Json(params: CommentsCommentIdPut$Json$Params, context?: HttpContext): Observable<CommentDto> {
    const resp = this.commentsCommentIdPut$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CommentDto>): CommentDto => r.body)
    );
  }

  /** Path part for operation `commentsCommentIdDelete()` */
  static readonly CommentsCommentIdDeletePath = '/comments/{commentId}';

  /**
   * Delete comment.
   *
   * Soft-deletes a comment.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentsCommentIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentsCommentIdDelete$Response(params: CommentsCommentIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = commentsCommentIdDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete comment.
   *
   * Soft-deletes a comment.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commentsCommentIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentsCommentIdDelete(params: CommentsCommentIdDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.commentsCommentIdDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `commentsCommentIdResolvePost()` */
  static readonly CommentsCommentIdResolvePostPath = '/comments/{commentId}/resolve';

  /**
   * Resolve comment.
   *
   * Marks a comment thread as resolved or unresolved.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentsCommentIdResolvePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  commentsCommentIdResolvePost$Plain$Response(params: CommentsCommentIdResolvePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CommentDto>> {
    const obs = commentsCommentIdResolvePost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Resolve comment.
   *
   * Marks a comment thread as resolved or unresolved.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commentsCommentIdResolvePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  commentsCommentIdResolvePost$Plain(params: CommentsCommentIdResolvePost$Plain$Params, context?: HttpContext): Observable<CommentDto> {
    const resp = this.commentsCommentIdResolvePost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CommentDto>): CommentDto => r.body)
    );
  }

  /**
   * Resolve comment.
   *
   * Marks a comment thread as resolved or unresolved.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentsCommentIdResolvePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  commentsCommentIdResolvePost$Json$Response(params: CommentsCommentIdResolvePost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CommentDto>> {
    const obs = commentsCommentIdResolvePost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Resolve comment.
   *
   * Marks a comment thread as resolved or unresolved.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commentsCommentIdResolvePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  commentsCommentIdResolvePost$Json(params: CommentsCommentIdResolvePost$Json$Params, context?: HttpContext): Observable<CommentDto> {
    const resp = this.commentsCommentIdResolvePost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CommentDto>): CommentDto => r.body)
    );
  }

}
